import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportListComponent } from './report-list/report-list.component';
import { ReportRoutingModule } from './report-routing.module';
import { RouterLink } from '@angular/router';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { ReportComponent } from './report.component';
import { CardComponentModule, ExportService, SharedModule } from 'lib-trend-core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ReportListContactComponent } from './report-list-contact/report-list-contact.component';
import { ReportListImportationComponent } from './report-list-importation/report-list-importation.component';
import { ReportCsatListComponent } from './report-csat-list/report-csat-list.component';
import { ReportAttendanceListComponent } from './report-attendance-list/report-attendance-list.component';
import { ReportTabulationAttendanceComponent } from './report-tabulation-attendance/report-tabulation-attendance.component';
import { ReportSalesMonitorComponent } from './report-sales-monitor/report-sales-monitor.component';
import { TrackingReportComponent } from './tracking-report/tracking-report.component';
import { ReportTemplatesAnalyticsComponent } from './report-templates-analytics/report-templates-analytics.component';
import { ReportConversationAnalyticsComponent } from './report-conversation-analytics/report-conversation-analytics.component';
import { AnalyticsCardComponent } from './report-conversation-analytics/analytics-card/analytics-card.component';
import { TemplateAnalyticsDetailComponent } from './report-templates-analytics/template-analytics-detail/template-analytics-detail.component';
import { ReportLeadSourceComponent } from './report-lead-source/report-lead-source.component';
import { ReportApiLoggingsComponent } from './report-api-loggings/report-api-loggings.component';
import { ReportApiLoggingsViewComponent } from './report-api-loggings/report-api-loggings-view/report-api-loggings-view.component';

@NgModule({
  declarations: [
    ReportListComponent,
    ReportComponent,
    ReportListContactComponent,
    ReportListImportationComponent,
    ReportCsatListComponent,
    ReportAttendanceListComponent,
    ReportTabulationAttendanceComponent,
    ReportSalesMonitorComponent,
    TrackingReportComponent,
    ReportConversationAnalyticsComponent,
    ReportTemplatesAnalyticsComponent,
    AnalyticsCardComponent,
    TemplateAnalyticsDetailComponent,
    ReportLeadSourceComponent,
    ReportApiLoggingsComponent,
    ReportApiLoggingsViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CardComponentModule,
    ReportRoutingModule,
    RouterLink,
    MatSelectModule,

    MatOptionModule,
    NgxChartsModule
  ],
  exports: [
    ReportListComponent,
    ReportComponent
  ],
  providers: [ExportService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportModule { }
